<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Search Form</v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input input-format="dd/mm/yyyy" v-model="from_date.value.value" label="From Date" prepend-icon="" prepend-inner-icon="mdi-calendar-month" single-line variant="outlined" density="compact" bg-color="grey-lighten-4" clearable :error-messages="from_date.errorMessage.value" />
                    </v-col>
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input input-format="dd/mm/yyyy" v-model="to_date.value.value" label="To Date" prepend-icon="" prepend-inner-icon="mdi-calendar-month" single-line variant="outlined" density="compact" bg-color="grey-lighten-4" clearable :error-messages="to_date.errorMessage.value" />
                    </v-col>
                    <v-col lg="2" md="2" cols="12">
                        <v-autocomplete v-model="payment_acc_account_head_id.value.value" :items="getPaymentAccountHeadList" :item-title="(item) => `${item.name ?? 'Select'}`" item-value="id" label="Payment Account Head" variant="outlined" density="compact" prepend-inner-icon="mdi-bank" clearable></v-autocomplete>
                    </v-col>
                    <v-col lg="2" md="2" cols="12">
                      <v-btn class="bg-brand w-15" type="submit" ref="searchButton">Search</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- 🔹 VAT Register List -->
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Bank Reconciliation Record</v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search" single-line hide-details density="compact" variant="outlined" bg-color="grey-lighten-4" clearable />
                  </v-col>
                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>
                </v-row>

                <!-- 🔹 Data Table -->
                <v-data-table :headers="headers" :items="getSchema" :loading="loading.value" :search="search" :hover="true" density="compact"  :items-per-page="-1" hide-default-footer>
                  <template v-slot:item.index="{ index }">{{ index + 1 }}</template>
                  <template v-slot:header.actions>
                    <v-checkbox v-model="selectAll" hide-details density="compact" @change="toggleSelectAll" />
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div class="text-center">
                      <v-checkbox checked v-model="item.selected" hide-details density="compact" @change="handleCheckboxChange()" />
                    </div>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip v-if="item.is_reconciled" color="success" size="small" class="text-capitalize">Paid</v-chip>
                    <v-chip v-else color="warning" size="small" class="text-capitalize">Not Paid</v-chip>
                  </template>
                  <template v-slot:body.append>
                    <tr style="background-color: #f5f5f5;">
                      <td colspan="7" class="text-right font-weight-bold">Total Amount:</td>
                      <td class=" font-weight-bold">{{ paymentTotalAmount }}</td>
                      <td class="font-weight-bold">{{ receiptTotalAmount }}</td>
                      <td class=" font-weight-bold">{{ balanceTotalAmount }}</td>
                      <td></td>
                    </tr>
                  </template>
                </v-data-table>

                <v-container class="d-flex justify-end mt-4 pa-4">
                  <v-form @submit.prevent="undoReconciliation">
                    <v-btn v-if="isAnyReconciliationSelected" type="submit" class="mr-2" color="warning" variant="flat"  size="small" > Undo Reconciliation </v-btn>
                  </v-form>
                  <v-btn v-if="isAnyReconciliationSelected" @click="openReconciliationModal" color="success" variant="flat" type="button" size="small" > Reconciliation Save </v-btn>
                </v-container>

              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

        <!-- =========================
         Reconcilation Modal/Dialog
         ========================= -->
    <v-dialog v-model="reconciliationModal" max-width="900">
      <v-card class="pa-5">
        <v-card-title>
          <span class="text-h6">Bank Reconcilation</span>
        </v-card-title>

        <v-form @submit.prevent="submitReconciliation">
          <v-card-text>
              <v-text-field
                v-model="payment_acc_account_head_id.value.value"
                variant="outlined"
                density="compact"
                hide-details
                maxlength="255"
                hidden
              ></v-text-field>
          </v-card-text>

          <v-date-input
            input-format="dd/mm/yyyy"
            v-model="reconciliation_month.value.value"
            label="Reconcilation Date *"
            variant="outlined"
            density="comfortable"
            prepend-icon=""
            prepend-inner-icon="mdi-calendar"
          ></v-date-input>

          <v-card-actions>
            <v-spacer />
            <v-btn variant="text" @click="closeReconciliation">Cancel</v-btn>
            <v-btn color="success" variant="flat" type="submit" size="small" :loading="loading.value">Submit</v-btn>
          </v-card-actions>
        </v-form>

      </v-card>
    </v-dialog>


  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref,watch } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  data: () => ({
    panel: [0],
    search: "",
    selectAll: false,
    totalSelectedAmount:0,
    isAnyReconciliationSelected:false,
    isAnyReconciliationNotSelected:false,
    payment_acc_account_head_id:null,
    reconciliation_month:null,
    // loading:false,
    reconciliationModal:false,
    headers: [
      { title: "#SL", key: "index", align: "center", width: "7%", sortable: false },
      { title: "Action", key: "actions", align: "left", width: "7%", sortable: false },
      { title: "Status", key: "status", align: "left", width: "7%", sortable: false },
      { title: "Date", key: "voucher_date", align: "center", sortable: true },
      { title: "Voucher No", key: "code", align: "left", sortable: true },
      { title: "Party", key: "party.name", align: "left", sortable: true },
      { title: "Cheque No", key: "cheque_no", align: "left", sortable: true },
      { title: "Payment", key: "payment_amount", align: "right", sortable: true },
      { title: "Receipt", key: "receipt_amount", align: "right", sortable: true },
      { title: "Balance", key: "balance", align: "right", sortable: true },
      
    ],
  }),

  watch: {
    "payment_acc_account_head_id.value.value"(val){
      if(!val){
        this.isAnyReconciliationSelected = false;
        this.$store.commit("UNSET_BANK_RECONCILATION_RECORD_LIST");
        this.selectAll = false;
      } 
    }
  },

  computed: {
    getSchema() {
      var data = this.$store.getters.bankReconciliationRecordList?.transactions || [];
      var isAnyNotSelected = false;
      var anyselected = false;
      data.forEach(item => {
        if (item.is_reconciled) {
            item.selected = true;
            anyselected = true;
        } else {
            item.selected = false;
            isAnyNotSelected = true;
        }
        this.selectAll = !isAnyNotSelected;
        this.isAnyReconciliationSelected = anyselected;
      
      });
      return data;
    },
    paymentTotalAmount() {
      return this.getSchema.reduce((sum, item) => sum + Number(item.payment_amount || 0), 0);
    },
    receiptTotalAmount() {
      return this.getSchema.reduce((sum, item) => sum + Number(item.receipt_amount || 0), 0);
    },
    balanceTotalAmount() {
      return this.$store.getters.bankReconciliationRecordList?.closing_balance;
    },
    getPaymentAccountHeadList() {
      return this.$store.getters.getPaymentAccountHeadList;
    },

  },

  created() {
    if (!this.$store.getters.bankReconciliationRecordList?.length) {
      this.$store.dispatch("bankReconciliationRecordList");
    }

    if (!this.$store.getters.getPaymentAccountHeadList?.length) {
        this.loading =  true;
        this.$store.dispatch("getPaymentAccountHeadList", {type: 'BANK'}).finally(() => {
            this.loading = false;
        });
    }
  },

  setup() {
    const store = useStore();
    const { handleSubmit } = useForm({ validationSchema: yup.object({}) });

    const { handleSubmit: handleReconciliationSubmit } = useForm({
      validationSchema: yup.object({
        //reconciliation_month: yup.date().required().label("Reconciliation Date"),
      }),
    });

    const {handleSubmit : handleUndoReconciliation} = useForm({ validationSchema: yup.object({}) });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const payment_acc_account_head_id = useField("payment_acc_account_head_id");
    const reconciliation_month = useField("reconciliation_month");
    const loading = ref(false);

    const submit = handleSubmit((values) => {
        loading.value = true;
        values.from_date = formattedDate(from_date.value.value);
        values.to_date = formattedDate(to_date.value.value);
        values.acc_account_head_id = payment_acc_account_head_id.value.value;
        store .dispatch("bankReconciliationRecordList", values) 
        .then(() => (
            loading.value = false
        )) .catch((error) => {
            loading.value = false;
            toast.error(error.response?.data?.message || "Error fetching data");
        });
    });

    const submitReconciliation = handleReconciliationSubmit((values) => {
        loading.value = true;
        values.acc_account_head_id = payment_acc_account_head_id.value.value;
        values.reconciliation_month = `${reconciliation_month.value.value.getFullYear()}-${(reconciliation_month.value.value.getMonth()+1).toString().padStart(2,'0')}`;

        const tax_items = (store.getters.bankReconciliationRecordList?.transactions || [])
        .filter(item => item.selected === true)
        .map(item => ({
          id: item.id,
        }));

        if(!payment_acc_account_head_id.value.value){
          loading.value = false;
          toast.error("Account Head not selected");
          return;
        }

        if (tax_items.length === 0) {
          loading.value = false;
          toast.error("No Reconciliation items selected");
          return;
        }

        values.acc_voucher_detail_id = tax_items;

        store .dispatch("bankReconciliationCheckout", values) 
        .then(() => (
            loading.value = false
        )) .catch((error) => {
            loading.value = false;
            toast.error(error.response?.data?.message || "Error fetching data");
        });
    });

    const undoReconciliation = handleUndoReconciliation((values) => {
      loading.value = true;

      if(!payment_acc_account_head_id.value.value){
        toast.error("Payment Account Head Not Selected");
        loading.value = false;
        return;
      }

      const tax_items = (store.getters.bankReconciliationRecordList?.transactions || [])
        .filter(item => item.selected === true)
        .map(item => ({
          id: item.id,
        }));

        if (tax_items.length === 0) {
          loading.value = false;
          toast.error("No Reconciliation items selected");
          return;
        }

        values.acc_account_head_id = payment_acc_account_head_id.value.value;
        values.acc_voucher_detail_id = tax_items;

      store.dispatch("bankReconciliationUndoCheckout", values) 
      .then(() => (
          loading.value = false
      )) .catch((error) => {
          loading.value = false;
          toast.error(error.response?.data?.message || "Error fetching data");
      });


    });

    return { submit,submitReconciliation,undoReconciliation, from_date, to_date, loading, payment_acc_account_head_id,reconciliation_month };
  },

  methods: {
    toggleSelectAll() {
      this.getSchema.forEach((item) => {
         item.selected = this.selectAll;
      });
       this.handleCheckboxChange();
    },
    handleCheckboxChange() {
      const selectableItems = this.getSchema;
      this.totalSelectedAmount = 0;
      this.isAnyReconciliationSelected = false;
      this.isAnyReconciliationNotSelected = false;
      selectableItems.forEach(item => {
      if (item.selected) {
        this.totalSelectedAmount += item.amount;
        this.isAnyReconciliationSelected = true;
      }else{
        this.isAnyReconciliationNotSelected = true;
      }
    });

    if (this.isAnyReconciliationNotSelected) {
      this.selectAll = false;
    } else {
      this.selectAll = true;
    }
      
    },

    openReconciliationModal() {
      if (!this.isAnyReconciliationSelected) {
        return toast.error("No Reconciliation items selected");
      }
      this.totalSelectedAmount = this.getSchema
        .filter(i => i.selected)
        .reduce((s, it) => s + Number(it.amount || 0), 0);

      this.reconciliationModal = true;
    },

    closeReconciliation() {
      this.reconciliationModal = false;
    },

    changeAccountHead(value){
      if(!value)this.reconciliationModal = false;
    }

  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton?.$el?.click();
    });
  },
};
</script>
